import { render, staticRenderFns } from "./PersonalInfoRequirementSummary.vue?vue&type=template&id=a88d6e6e"
import script from "./PersonalInfoRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./PersonalInfoRequirementSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports